module.exports = __webpack_public_path__ + "static/media/lumpnotes_ios.3bf326b7.png";